// Module
var code = "<h1 id=card-卡片>Card 卡片</h1> <p>通用卡片容器。</p> <p>最基础的卡片容器，可承载文字、列表、图片、段落，常用于后台概览页面。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>查询条件块。</li> <li>查询表格块。</li> <li>详情信息分块。</li> </ul> ";
// Exports
module.exports = code;